<template><OperatingCalculator /></template>
<script>
import OperatingCalculator from '../OperatingCalculator.vue';
export default { components: { OperatingCalculator }, props: { assetName: Array } };
</script>
